import { Logger } from './utilities/logger';
import mitt from 'mitt';
/**
 * Base for a consent option group.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class AbstractGroup {
    /**
     * @param {A11yConsentApi} api A11y Consent API
     * @param {AbstractGroupData} data Group data from the global configuration object
     */
    constructor(api, data) {
        // Emits events related to the group
        this.emitter = mitt();
        // Consent options of this group
        this.options = {};
        this.uid = data.uid;
        Logger.debug('abstract-group', `Starting to construct "${this.uid}".`);
        this.api = api;
        this.title = data.title;
        this.description = data.description;
        this.optionsCount = Object.keys(data.options).length;
        Logger.debug('abstract-group', `Finished constructing "${this.uid}".`);
    }
}
